module.exports = __webpack_public_path__ + "img/88ne.d0bada8b.svg";